import React, { useState, useCallback, useContext } from 'react';
import { ConfirmationModal, TextArea } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const DeclineReasonModal = ({ onClose, handleClientDecline }) => {
  const { t } = useContext(ConfigContext);
  const [clientDeclineReason, setClientDeclineReason] = useState(null);

  const onDecline = useCallback(async () => {
    await handleClientDecline({ clientDeclineReason });
    onClose();
  }, [clientDeclineReason, handleClientDecline, onClose]);

  return (
    <ConfirmationModal
      onConfirm={onDecline}
      usePortal
      onClose={onClose}
      title={t('declineReason')}
      disabledConfirm={!clientDeclineReason}
      confirmText="ok">
      <TextArea
        value={clientDeclineReason}
        onChange={setClientDeclineReason}
        placeholder={t('addNotes')}
        minRows={4}
        maxLength={1000}
      />
    </ConfirmationModal>
  );
};

export default DeclineReasonModal;
